function excerptify(str, max = 26) {
  if (!str || typeof str !== "string") return "";
  if (str.length <= max) return str;
  return str.substring(0, max) + "...";
}

export default excerptify;
